import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "./footer";

const API_BASE = "https://api.niveshly.com";

function ExploreCompanies() {
  const navigate = useNavigate();

  const [companies, setCompanies] = useState([]);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [selectedKeyword, setSelectedKeyword] = useState("All");

  const keywords = [
    "All", "HOTEL", "EDUCATION", "AGRICULTURE", "ELECTRONICS", "HEALTHCARE",
    "MANUFACTURING", "MINERALS", "FOOD & BEVERAGE", "STEEL", "INSURANCE",
    "HOSPITALITY", "INFRASTRUCTURE", "DEFENCE", "AUTOMOTIVE",
    "ENERGY", "IT", "FINANCE", "OTHER"
  ];

  const createSlug = (name) =>
    name
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");

  useEffect(() => {
    fetch(`${API_BASE}/companies`)
      .then(res => res.json())
      .then(data => {
        setCompanies(data);
        setFilteredCompanies(data);
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const handleKeywordClick = (keyword) => {
    setSelectedKeyword(keyword);
    let temp = companies;
    if (keyword !== "All") {
      temp = temp.filter(c => c.tag?.toUpperCase() === keyword);
    }
    setFilteredCompanies(temp);
  };

  useEffect(() => {
    let filtered = companies.filter(c =>
      c.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    if (selectedKeyword !== "All") {
      filtered = filtered.filter(
        c => c.tag?.toUpperCase() === selectedKeyword
      );
    }

    if (sortOrder === "trending") {
      filtered = filtered.filter(c => c.trending);
    } else if (sortOrder === "asc") {
      filtered = filtered.sort((a, b) => a.name.localeCompare(b.name));
    } else if (sortOrder === "desc") {
      filtered = filtered.sort((a, b) => b.name.localeCompare(a.name));
    }

    filtered = filtered.sort((a, b) => a.position - b.position);
    setFilteredCompanies(filtered);
  }, [searchQuery, sortOrder, companies, selectedKeyword]);

  return (
    <div style={{ padding: "40px 20px", maxWidth: "1400px", margin: "0 auto" }}>
      <h1 style={{ fontSize: "32px", fontWeight: "700", marginBottom: "30px", color: "#1a202c" }}>
        Explore Companies
      </h1>

      <div style={{ display: "flex", gap: "15px", marginBottom: "25px", flexWrap: "wrap" }}>
        <input
          placeholder="Search company..."
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          style={{
            flex: "1",
            minWidth: "250px",
            padding: "12px 16px",
            border: "1px solid #e2e8f0",
            borderRadius: "8px",
            fontSize: "15px"
          }}
        />
        <select
          value={sortOrder}
          onChange={e => setSortOrder(e.target.value)}
          style={{
            padding: "12px 16px",
            border: "1px solid #e2e8f0",
            borderRadius: "8px",
            fontSize: "15px",
            backgroundColor: "white"
          }}
        >
          <option value="asc">Sort: A to Z</option>
          <option value="desc">Sort: Z to A</option>
          <option value="trending">Show Only Trending</option>
        </select>
      </div>

      <div style={{ display: "flex", gap: "10px", marginBottom: "30px", flexWrap: "wrap" }}>
        {keywords.map(kw => (
          <button
            key={kw}
            onClick={() => handleKeywordClick(kw)}
            style={{
              padding: "8px 16px",
              border: "1px solid #e2e8f0",
              borderRadius: "6px",
              backgroundColor: selectedKeyword === kw ? "#4f46e5" : "white",
              color: selectedKeyword === kw ? "white" : "#4b5563",
              fontSize: "14px",
              cursor: "pointer"
            }}
          >
            {kw}
          </button>
        ))}
      </div>


      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))", gap: "25px" }}>
        {filteredCompanies.map((c, i) => (
          <div
            key={i}
            onClick={() =>
              navigate(`/company/${c.id}/${createSlug(c.name)}`)
            }
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              padding: "20px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              cursor: "pointer",
              position: "relative"
            }}
          >
            <div style={{ display: "flex", gap: "15px", marginBottom: "15px" }}>
              <img src={c.logo} alt={c.name} style={{ width: 50 }} />
              <h2 style={{ margin: 0 }}>{c.name}</h2>
            </div>

            {/* <div style={{ display: "flex", alignItems: "center", gap: "15px", marginBottom: "15px" }}>
                <img
                  src={c.logo}
                  alt={c.name}
                  style={{ width: "50px", height: "50px", objectFit: "contain" }}
                />
                <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#1a202c", margin: 0 }}>{c.name}</h2>
              </div> */}

            <div style={{ display: "flex", gap: "8px", marginBottom: "15px", flexWrap: "wrap" }}>
              <span style={{
                padding: "6px 12px",
                backgroundColor: "#10b981",
                color: "white",
                borderRadius: "6px",
                fontSize: "14px",
                fontWeight: "600"
              }}>
                {c.price}
              </span>
              {c.trending && (
                <span style={{
                  padding: "6px 12px",
                  backgroundColor: "#f59e0b",
                  color: "white",
                  borderRadius: "6px",
                  fontSize: "14px",
                  fontWeight: "600"
                }}>
                  🔥 Trending
                </span>
              )}
              <span style={{
                padding: "6px 12px",
                backgroundColor: c.availability ? "#dbeafe" : "#fee2e2",
                color: c.availability ? "#1e40af" : "#991b1b",
                borderRadius: "6px",
                fontSize: "14px",
                fontWeight: "600"
              }}>
                {c.availability ? "✓ Available" : "✗ Unavailable"}
              </span>
            </div>

            <div style={{ marginBottom: "15px", color: "#4b5563", fontSize: "14px", lineHeight: "1.6" }}>
              <p style={{ margin: "5px 0" }}><strong>Min. Quantity:</strong> {c.quantity}</p>
              <p style={{ margin: "5px 0" }}><strong>ISIN:</strong> {c.isin}</p>
              <p style={{ margin: "5px 0" }}><strong>PAN:</strong> {c.pan}</p>
              {/* <p style={{ margin: "10px 0 0 0", color: "#6b7280" }}>{c.description}</p> */}
            </div>

            <div style={{
              position: "absolute",
              top: "15px",
              right: "15px",
              padding: "4px 10px",
              backgroundColor: "#4f46e5",
              color: "white",
              borderRadius: "4px",
              fontSize: "12px",
              fontWeight: "600"
            }}>
              {c.tag}
            </div>
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
}

export default ExploreCompanies;
